import { GbpLocationGroup } from '../../../../models/locations-models/gbp-location-group';
import { EntityState } from '@ngrx/entity';
import { CCLocation } from '../../../../models/locations-models/cc-location';
import { SortingEnum } from '../../enums/sorting-enum';
import { CCRowSetting } from '../../../../models/locations-models/cc-row-setting';
import { ccDataAdapter } from './cc-list-adapters';

// Types

export interface CCLocations extends EntityState<CCLocation> {
}

export interface CCRowSettings extends EntityState<CCRowSetting> {
}

export interface CCData extends EntityState<CCDataPerLocation> {
}

export interface CCDataPerLocation {
  id: number; // (BLS) location ID
  ccLocations: CCLocations;
  ccRowSettings: CCRowSettings;
  ccLocationsLoading: boolean;
  timestamp: number; // unix timestamp in ms
  // Altering an ImportedLocation in any way (editing BLS fields, black-/whitelisting,
  // accepting/ignoring diffs, etc. can affect the CC candidates of a given location,
  // possibly even CC candidates of other locations within a given radius (BE should document this)
  // Since refreshing CC candidates is an expensive operation, lets at least make sure
  // that we highlight the refresh button after such operations on the underlying LSC
  // location
  // Currently dispatching 'patchLocation(s)' and 'markAllCCListsAsStale' will set this to 'true' and the reducer that handles
  // 'updateCCListSuccess' resets it back to false
  possiblyOutOfDate: boolean;
}

export interface CCListState {
  ccData: CCData,
  ccLocationGroup: GbpLocationGroup | null;
  ccRadius: number | null;
  ccKeywords: string[] | null;
  sorting: SortingEnum;
  continueAfterClaim: boolean;
  continueAfterCreate: boolean;
}

// Initial State

export const initialState: CCListState = {
  ccData: ccDataAdapter.getInitialState(),
  ccLocationGroup: null,
  ccRadius: null,
  ccKeywords: null,
  sorting: SortingEnum.NONE,
  continueAfterClaim: false,
  continueAfterCreate: false,
};
